<template>
	<v-card
		width="250px"
		min-height="60px"
		rounded
		outlined
		hover
		ripple
		style="cursor: pointer"
		@click="$emit('click', data)"
	>
		<v-card-text style="position: relative; height:100%">
			<div class="font-weight-bold">{{ positions }}</div>
			<div :class="{'mt-1': data.teasertypes.length !== 0}">
				<v-chip v-for="(teasertype, i) in data.teasertypes" :key="'teasertype_'+i"
								small dark
								:ripple="false" :color="type === 'stage' ? ada.blue : ada.pink"
								:class="{'mr-2': i+1 !== data.teasertypes.length}"
				>
					{{ teasertype }}
				</v-chip>
			</div>
			<v-tooltip top>
				<template v-slot:activator="{ on, attrs }">
					<v-icon
						v-bind="attrs"
						v-on="on"
						x-small
						class="comparisonDot"
						:color="isEqual.color"
					>mdi-circle
					</v-icon>
				</template>
				<span>{{ isEqual.tooltip }}</span>
			</v-tooltip>

			<v-tooltip top>
				<template v-slot:activator="{ on, attrs }">
					<v-icon
						:disabled="$store.state.readOnly !== 0"
						v-bind="attrs"
						v-on="on"
						x-small
						class="deleteIcon"
						:color="ada.grey"
						@click.stop="$emit('click:delete')"
					>mdi-delete
					</v-icon>
				</template>
				<span>Dieses Template löschen</span>
			</v-tooltip>
		</v-card-text>
	</v-card>
</template>

<script>
import ada from "../../../scss/ada_colors.scss";
import Utils from "../../../scripts/Utils";

export default {
	name: "JsonEntryTile",
	props: ['type', 'data'], //{ "type": "Index", "positions": [ "teaser_11", "teaser_12" ], "teasertypes": [ "Anzeige" ], "completeKey": "teaser_11_index_Anzeige, teaser_12_index_Anzeige" },
	data: () => {
		return {
			ada
		}
	},
	computed: {
		vuexState() {
			return this.$store.state.editor;
		},
		positions() {
			return this.data ? this.data.positions.join(', ') : '';
		},
		isEqual() {
			let comparedEnv = this.type === 'live' ? 'STAGE' : 'LIVE';
			let ret = {color: 'green', tooltip: 'Identisch mit ' + comparedEnv};
			if (this.vuexState.jsonContent_live && this.vuexState.jsonContent_stage) {
				let liveKey = this.type === 'live' ? this.data.completeKey : this.correspondingKey(this.data.completeKey);
				let stageKey = this.type === 'stage' ? this.data.completeKey : this.correspondingKey(this.data.completeKey);
				let liveEntry = this.vuexState.jsonContent_live[liveKey];
				let stageEntry = this.vuexState.jsonContent_stage[stageKey];
				if (typeof liveEntry !== "undefined" && typeof stageEntry !== "undefined") {
					if (Utils.uglifyHTML(Utils.prettifyHTML(liveEntry)) !== Utils.uglifyHTML(Utils.prettifyHTML(stageEntry))) { //ignore whitespace difference
						ret.color = 'orange';
						ret.tooltip = `Nicht identisch mit ${comparedEnv}`
					}
				} else {
					ret.color = 'red';
					ret.tooltip = `Existiert nicht auf ${comparedEnv}`
				}
			}
			return ret;
		},
	},
	methods: {
		correspondingKey() {
			let ret = this.data.completeKey;
			let corEnv = this.type === 'live' ? 'stage' : 'live';
			let currentKeys = this.data.completeKey.replaceAll(' ', '').split(',');
			let keys = [];
			if (this.vuexState['jsonContent_' + corEnv]) {
				Object.keys(this.vuexState['jsonContent_' + corEnv]).forEach((key) => {
					keys.push({
						templates: key.replaceAll(' ', '').split(','),
						completeKey: key
					})
				})
			}
			for (let i = 0; i < keys.length; i++) {
				if ((currentKeys.length === keys[i].templates.length) &&
					(currentKeys.sort().join(',') === keys[i].templates.sort().join(','))) {
					ret = keys[i].completeKey;
					break;
				}
			}
			return ret;
		}
	}

}
</script>

<style lang="scss" scoped>
::v-deep .v-card__text {
	padding: 10px 15px;
}

.comparisonDot {
	position: absolute;
	top: 7px;
	right: 5px;
}

.deleteIcon {
	position: absolute;
	font-size: 18px !important;
	bottom: 5px;
	right: 3px;

	&:hover {
		color: $ada_red !important;
	}

	&.v-icon--disabled {
		color: white !important;
	}
}
</style>